import HelpBox from '@/components/common/HelpBox';
const RenderHelpBox = (title = '', description = '') => {
  return (
    <HelpBox>
      <div className={`flex flex-col justify-start align-start`}>
        <span>{description}</span>
      </div>
    </HelpBox>
  );
};

export default RenderHelpBox;
